/**
 * Featured Product Testimonials V2 Section
 * 3-column grid on desktop, slider with 1 per page on mobile
 */

window.initFeaturedProductTestimonialsV2Slider = function(section) {
  if (!section || typeof Splide === 'undefined') return null;

  const sliderEl = section.querySelector('.js-testimonials-v2-slider');
  
  if (!sliderEl) return null;

  const blockCount = parseInt(section.dataset.blockCount || '0', 10);
  let slider = null;

  // Initialize slider
  function initSlider() {
    // Destroy existing instance if it exists
    if (slider) {
      try {
        slider.destroy();
      } catch (e) {
        console.warn('Error destroying slider:', e);
      }
      slider = null;
    }

    // Mobile slider - 1 per page
    slider = new Splide(sliderEl, {
      type: 'slide',
      rewind: true,
      arrows: false,
      pagination: false,
      perPage: 1,
      perMove: 1,
      gap: '1rem',
      padding: { right: '12%', left: 0 },
      speed: 400,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      mediaQuery: 'min',
      breakpoints: {
        1100: {
          perPage: 3,
          perMove: 1,
          gap: '1.5rem',
          padding: 0,
          destroy: blockCount <= 3 // Only destroy if 3 or fewer blocks
        },
        768: {
          perPage: 2,
          padding: { right: '12%', left: 0 },
          destroy: blockCount <= 2 // Only destroy if 2 or fewer blocks
        }
      },
      i18n: {
        prev: 'Previous testimonial',
        next: 'Next testimonial',
        first: 'Go to first testimonial',
        last: 'Go to last testimonial',
        slideX: 'Go to testimonial %s',
      }
    });

    // Mount slider
    slider.mount();

    // Setup custom controls using SplideUtils
    if (typeof window.SplideUtils !== 'undefined') {
      // Setup scrollbar
      window.SplideUtils.setupScrollbar(slider, section);

      // Setup bottom arrows
      const arrows = section.querySelector('.custom-splide-arrows--v2');
      if (arrows) {
        window.SplideUtils.setupCustomArrows(slider, arrows);
      }

      // Setup header arrows
      const headerArrows = section.querySelector('.custom-splide-arrows--header');
      if (headerArrows) {
        window.SplideUtils.setupCustomArrows(slider, headerArrows);
      }
    }
  }

  // Initialize on load
  initSlider();

  // Return cleanup function
  return {
    slider: slider,
    destroy: function() {
      if (slider) slider.destroy();
    },
    refresh: function() {
      if (slider) slider.refresh();
    }
  };
};

// Initialize all sections on page load
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[id^="FeaturedProductTestimonialsV2-"]');
  sections.forEach(function(section) {
    section.sliderInstance = window.initFeaturedProductTestimonialsV2Slider(section);
  });
});

// Setup theme editor events
if (typeof window.SplideUtils !== 'undefined') {
  window.SplideUtils.setupThemeEditorEvents(
    'FeaturedProductTestimonialsV2-',
    '.js-testimonials-v2-slider',
    (sectionElement) => {
      const section = sectionElement.querySelector('[id^="FeaturedProductTestimonialsV2-"]');
      if (section) {
        // Destroy existing instance
        if (section.sliderInstance?.destroy) {
          section.sliderInstance.destroy();
        }
        
        // Reinitialize
        section.sliderInstance = window.initFeaturedProductTestimonialsV2Slider(section);
      }
    }
  );
}
